
import { Badge } from "@/components/ui/badge";
import { Briefcase, Sun, Users, Laptop } from "lucide-react";
import { Trip } from "@/types/trip";

interface TripCardBadgesProps {
  tripType?: string;
  numberOfTravelers?: number;
}

export const getTripTypeIcon = (type?: string) => {
  switch (type?.toLowerCase()) {
    case 'business':
      return <Briefcase className="w-3 h-3" />;
    case 'leisure':
      return <Sun className="w-3 h-3" />;
    case 'family':
      return <Users className="w-3 h-3" />;
    case 'bleisure':
      return <Laptop className="w-3 h-3" />;
    default:
      return null;
  }
};

const TripCardBadges = ({ tripType, numberOfTravelers }: TripCardBadgesProps) => {
  return (
    <div className="flex items-center gap-2">
      {tripType && (
        <Badge variant="secondary" className="text-xs flex items-center gap-1">
          {getTripTypeIcon(tripType)}
          <span>{tripType}</span>
        </Badge>
      )}
      {numberOfTravelers && (
        <Badge variant="outline" className="text-xs flex items-center gap-1">
          <Users className="w-4 h-4" />
          <span>{numberOfTravelers}</span>
        </Badge>
      )}
    </div>
  );
};

export default TripCardBadges;
